export const gameTypeLabelsReversed = {
  'Account Classification': 'ACC',
  'Normal Balance': 'NOR',
  'Balanced Equation': 'BE',
  'The Principles': 'PR',
};